// extracted by mini-css-extract-plugin
export default {"buttonCommon":"buttonCheckoutCustom_buttonCommon__ZYM6V"};